import { render } from "./PageComponent.vue?vue&type=template&id=3b5823a0"
import script from "./PageComponent.vue?vue&type=script&lang=js"
export * from "./PageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/page/PageComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b5823a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b5823a0', __exports__)) {
    api.reload('3b5823a0', __exports__)
  }
  
  module.hot.accept("./PageComponent.vue?vue&type=template&id=3b5823a0", () => {
    api.rerender('3b5823a0', render)
  })

}


export default __exports__